module.exports = __webpack_public_path__ + "img/trunk_9x3.02eced14.svg";